<mat-expansion-panel [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6>Site and Project Info</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-list class="site-info-list">
    <mat-list-item>
      <img src="./assets/img/jap_img.jpg" width="100%" alt="site info image" />
    </mat-list-item>
    <mat-list-item>
      <mat-icon
        aria-hidden="false"
        aria-label="weather icon"
        class="Bosch-Ic-information"
        style="width: max-content"
      ></mat-icon>
      &nbsp; {{ model.siteName }}, {{ model.addressBlockNo }},
      {{ model.addressLocality }}, {{ model.city }}, {{ model.pinCode }}
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-divider></mat-divider>
    <mat-list-item>
      <mat-icon
        aria-hidden="false"
        aria-label="weather icon"
        class="Bosch-Ic-information"
        style="width: max-content"
      ></mat-icon>
      &nbsp; Last Logged in: {{ lastLoginTime }}
    </mat-list-item>
  </mat-list>
</mat-expansion-panel>
